export default function normalizeTag(tag: string): string {
  return tag
    .split('/')
    .map((part) => part.trim())
    .filter((part) => part.length)
    .join('/');
}
